/**
 * Most pulled from Facebook's fbjs package.
 * Ref: https://github.com/facebook/fbjs/blob/17fad9eec9847a81671d0d7b4ad177760e8eb1ff/packages/fbjs/src/core/shallowEqual.js
 */

const hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Inlined Object.is polyfill to avoid requiring consumers ship their own
 * Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
const is = (x: unknown, y: unknown): boolean => {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / (x as number) === 1 / (y as number);
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
};

/**
 * Tests if the two passed params are shallowly equal. Performs equality by
 * iterating through keys on an object and returning false when any key has
 * values which are not strictly equal between the arguments. Returns true when
 * the values of all keys are strictly equal.
 * @param objA The first value to compare.
 * @param objB The second value to compare.
 */
export const isShallowEqual = (objA: unknown, objB: unknown): boolean => {
  if (is(objA, objB)) {
    return true;
  }

  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (const key of keysA) {
    if (!hasOwnProperty.call(objB, key) || !is(objA[key], objB[key])) {
      return false;
    }
  }

  return true;
};
